import { Expose } from "class-transformer";

export class AddWorksheetsToCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  worksheetIds: string[];
}
